// TODO: DEPRECATED

import portaro from '../portaro';
import {getErrorMessage, responseToData} from 'shared/utils/data-service-utils';

/**
 * @deprecated
 */
portaro.directive('jpGlobalSearchInput', ['$http', 'CONTEXT_PATH', 'TEMPLATES_PATH', '$timeout',
    function($http, CONTEXT_PATH, TEMPLATES_PATH, $timeout, $log) {

        var getValues = function(inputValue) {
            var params = {
                infix: inputValue
            };
            return $http.get(CONTEXT_PATH + '/api/autocomplete/searched-terms', {params: params})
                .then(responseToData)
                .then(function(data) {
                    return data.content.map(function(item) {
                        return item.value;
                    });
                })
                ['catch'](function(data) {
                    $log.log(getErrorMessage(data));
                });
        };

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATES_PATH + 'jp-global-search-input.html',
            scope: {
                prefilledValue: "@"
            },
            link: function ($scope, element, attributes) {
                $scope.query = $scope.prefilledValue || '';
                $scope.getValues = getValues;
                $scope.onSelect = function(item, model) {
                    var parentForm = $(element[0]).parents("form");
                    if (parentForm) {
                        $timeout(function() {
                            parentForm.submit();
                        });
                    }
                    return true;
                };
            }
        };
    }]);